import { Button } from '@aon/aon-tws-common-ui';
import errorIcon from '@aon/aon-tws-common-ui/build/lib/assets/images/icon-error.svg';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import styled, { css } from 'styled-components';

export const ButtonErrorCss = css`
	border: 1px solid !important;
	border-color: #ff0000 !important;
`;

export const ErrorMessageLabelNoIcon = styled('div')`
	font-size: 12px;
	font-weight: 500;
	text-align: left;
	margin-top: 5px;
	margin-bottom: 5px;
	min-height: 20px;
	color: #ff0000;
	line-height: 1.1em;
	padding-top: 3px;
`;
ErrorMessageLabelNoIcon.displayName = 'ErrorMessageLabelNoIcon';

export const ErrorMessageLabel = styled(ErrorMessageLabelNoIcon)`
	background-image: url(${errorIcon});
	background-repeat: no-repeat;
	background-size: 14px 14px;
	background-position: 0px 2px;

	padding-left: 20px;
`;
ErrorMessageLabel.displayName = 'ErrorMessageLabel';

export const AddPlaceholderContainer = styled.div`
	margin-top: 5px;
	margin-left: 15px;
	font-size: 12px !important;
	text-align: left;
	width: 100%;
	span {
		margin-left: 5px;
	}
`;

export const AddPlaceholderButton = styled(Button)<{ error?: string; backgroundcolor?: string }>`
	&& {
		${(props) => (props.error === 'true' ? ButtonErrorCss : '')}
		background-color: ${(props) => (props.backgroundcolor ? `${props.backgroundcolor} !important` : 'unset')};
		i {
			color: ${(props) => (props.backgroundcolor ? `${globalVars.white} !important` : 'unset')};
		}
	}
`;
AddPlaceholderButton.displayName = 'AddPlaceholderButton';

export const SwitchWithLabelContainer = styled('div')`
	display: flex;
	align-items: center;
	padding-bottom: 20px;

	& .tws-input-switch-wrapper {
		margin-right: 10px;
	}
`;
SwitchWithLabelContainer.displayName = 'SwitchWithLabelContainer';

export const SendEmailContainer = styled.div`
	width: 100%;
	text-align: left;
`;
SendEmailContainer.displayName = 'SendEmailContainer';
